module.exports = __webpack_public_path__ + "static/media/placeholder_pp_bg-removed-bw.498ac74b.png";